import { render } from "./popularAnswerBoard.vue?vue&type=template&id=0095e1e2&scoped=true"
import script from "./popularAnswerBoard.vue?vue&type=script&lang=js"
export * from "./popularAnswerBoard.vue?vue&type=script&lang=js"

import "./popularAnswerBoard.vue?vue&type=style&index=0&id=0095e1e2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0095e1e2"]])

export default __exports__